<template>
    <div class="parametric-projects">
        <button
            class="button parametric-projects__button"
            @click="showComplexes">
            <span class="button__text">Подробнее про проекты</span>
            <span class="button__icon">
                <PlusIcon
                    v-if="!isComplexesVisible"
                    class-name="icon-stroke icon_color_white" />
                <MinusIcon
                    v-else
                    class-name="icon-stroke icon_color_white" />
            </span>
        </button>

        <div
            class="transition-block"
            :style="{ opacity: animationOpacity, display: animationDisplay}">
            <div v-if="isComplexesVisible">
                <ParametricProject
                    v-for="(project, index) in projects"
                    :key="index"
                    :project="project" />
            </div>
        </div>
    </div>
</template>

<script>
import MinusIcon from '@/components/Icons/Minus.vue';
import ParametricProject from '../ParametricProject/ParametricProject.vue';
import PlusIcon from '@/components/Icons/PlusThin.vue';

export default {
    name: 'ParametricComplexes',

    components: {
        MinusIcon,
        ParametricProject,
        PlusIcon
    },

    props: {
        projects: {
            type   : Array,
            default: () => []
        }
    },

    data() {
        return {
            isComplexesVisible: false, // Показываем ли комплексы
            animationOpacity  : 0,
            animationDisplay  : 'none'
        };
    },

    methods: {
        showComplexes() {
            this.isComplexesVisible = !this.isComplexesVisible;

            setTimeout(() => {
                this.animationDisplay = this.isComplexesVisible ? 'block' : 'none';
            }, this.isComplexesVisible ? 50 : 180);

            setTimeout(() => {
                this.animationOpacity = this.isComplexesVisible ? '1' : '0';
            }, 150);
        }
    }
};
</script>

<style lang="scss">
@import './ParametricProjectsList.scss';
</style>